import React, { useContext, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap'
import { CodingEventTable } from '../../../controls/';
import ConditionalRender from '../../../controls/formControls/ConditionalRender';
import { CodingEventQueueContext } from '../../../contexts/CodingEventQueueContext';


const MyQueue = (props) => {

    const filterType = 'myQueue';

    const context = useContext(CodingEventQueueContext);

    useEffect(() => {
        context.setFilterType(filterType);
    }, []);

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >{context.editMode ? "Editing Selected Events" : "Coding Events"}</div>
                <div className="card-btn-group">
                    <ConditionalRender visible={context.filtered}>
                        <Button variant="secondary" size="sm" onClick={() => context.resetFilters()}>Clear Filters</Button>
                    </ConditionalRender>
                </div>
            </Card.Header>
            <Card.Body className="card-body-table">
                <CodingEventTable
                    pageSize="30"
                    canBulkEdit
                />
            </Card.Body>
        </Card>
    )
}

export default MyQueue;